import { ChangeEvent, FC, KeyboardEvent, useEffect, useState } from "react";
import { Input, PrimaryButton, SecondaryButton, Stack } from "flicket-ui";
import CustomModal from "~components/CustomModal";
import { useOrganization } from "~hooks";

interface AccessCodeModalProps {
  type: "membership" | "event";
  isOpen: boolean;
  isLoading: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (accessCode: string) => Promise<void>;
}

export const AccessCodeModal: FC<AccessCodeModalProps> = ({
  type,
  isOpen,
  isLoading,
  error,
  onClose,
  onSubmit,
}) => {
  const [accessCode, setAccessCode] = useState("");

  const { t } = useOrganization();

  useEffect(() => {
    sessionStorage.removeItem("accessCodeId");
  }, []);

  const handleSubmit = () => {
    void onSubmit(accessCode);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setAccessCode(e.target?.value ?? "");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      void handleSubmit();
    }
  };

  return (
    <CustomModal isOpen={isOpen} close={onClose}>
      <CustomModal.Header>Have an access code?</CustomModal.Header>
      <CustomModal.Content>
        <Input
          placeholder="Enter access code..."
          value={accessCode}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          error={error}
          autoFocus
        />
      </CustomModal.Content>
      <CustomModal.Footer>
        <Stack
          direction="horizontal"
          justifyContent={{
            _: "center",
            sm: "flex-end",
          }}
          w={{
            _: "100%",
            md: "auto",
          }}
          gap={2}
        >
          <SecondaryButton onClick={onClose}>Go back</SecondaryButton>
          <PrimaryButton
            onClick={handleSubmit}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Access{" "}
            {type === "membership" ? t("membership_name_plural") : "tickets"}
          </PrimaryButton>
        </Stack>
      </CustomModal.Footer>
    </CustomModal>
  );
};
